import { Account } from './../../models/account';
import { API_URL } from './../../app.constant';
import { HttpParams, HttpClient } from '@angular/common/http';
import { Booking } from './../../models/booking';
import { Injectable } from '@angular/core';

const OBS_GETUPCOMINGBOOKING = "OBS_GetUpComingBooking";

const COM_CANCELBOOKING = "COM_CancelBooking";


@Injectable({
  providedIn: 'root'
})
export class ObsDataService {

  constructor(private http: HttpClient) { }


  // retrieveAllBookings(accountId) {


  //   let params = new HttpParams().set('accountId', accountId);


  //   return this.http.get<Booking[]>(`${API_URL}/${OBS_GETUPCOMINGBOOKING}`, { params });
  // // }

  // getUpcomingBooking(accountId) {


  //   let params = new HttpParams().set('accountId', accountId);

  //   return this.http.get<Booking[]>(`${API_URL}/${OBS_GETUPCOMINGBOOKING}`, { params });
  // }



}
